<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"><i class="fas fa-umbrella-beach text-primary"></i> Holiday</h5>
      </div>
      <hr />
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label">Holiday Name<sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.Name" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Start Date<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="date" class="form-control form-control-sm" v-model="Obj.startDate" />
        </div>
        <div class="col-md-3">
          <label class="form-label">End Date<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="date" class="form-control form-control-sm" v-model="Obj.endDate" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Note <sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.Note" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Image :</label>
         <label for="fileInput" class="attachment-icon" >
              <i class="fa fa-upload"></i>
            </label>
          <input class="form-control" id="fileInput" type="file" multiple accept=".png,.jpg,.jpeg,.webp,.pdf,.docx,.doc,.xls,.txt" @change="UploadImg" />
           <div class="d-flex align-items-start">
          <a v-if="Obj.Image" :href="getUrl(Obj.Image)" target="_blank"  class="clearfix">{{Obj.Image.substring(Obj.Image.lastIndexOf('/') + 1)  }} </a>
          <i role="button" v-if="Obj.Image !== ''" @click="deleteFile(Obj.Image)" class="fa-solid fa-x text-danger f-5 mt-2 ms-1"></i>
        </div></div>
        <div class="col-md-9 text-end mt-5">
          <button class="btn btn-sm btn-darknavy me-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
           <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
        </div>
      </div>
       <ul v-if="errors.length" class="text-danger ps-3">
          <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
        </ul>
      <div class="row">
        <div class="col-md-12 table-responsive mt-2">
          <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
      </div>
          <DataTable v-if="progress==0" :columns="cols" :rows="rows" :pageSize="10"   :actions="{  edit: handleEdit, delete: handleDelete }" />
        </div>
      </div>
    </div>
  </div>
  <DelPopup :name="delObj.Name" @delRecord="delRecord" @closeModal="delObj.Name = ''"></DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm } from "@/utils/validation.js";
import { useFileUpload } from "@/utils/fileUpload";
const { handleFileUploadImg } = useFileUpload();
import { formatDate, curdStatus, api } from '@/utils/helpers.js';
import { ref, onMounted} from 'vue'
  const  Obj = ref( { Name: "", startDate: new Date().toISOString().slice(0, 10), endDate: new Date().toISOString().slice(0, 10), Image: "", Note: "", })
    const   msgObj= ref({ msg: "", role: "", show: false, })
    const   delObj = ref({})
    const   errors= ref({})
const cols=ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Name', key: 'Name' },
  { label: 'Start Date', key: 'Datestart' },
  { label: 'End Date', key: 'Dateend' },
  { label: 'Image', key: 'Image' ,type:'image'},
  { label: 'Note', key: 'Note', truncatable: true }
]);
const handleEdit = (row) => {
    Obj.value = { ...row,
      startDate: row.startDate ? row.startDate.slice(0, 10) : new Date().toISOString().slice(0, 10),
      endDate: row.endDate ? row.endDate.slice(0, 10) : new Date().toISOString().slice(0, 10),
     }
     if (Obj.value.Image?.startsWith(process.env.VUE_APP_API_URL)) {
    Obj.value.Image = Obj.value.Image.replace(process.env.VUE_APP_API_URL, '');
  }
}
  const UploadImg = async (event) => {
  const file = event.target.files[0];
  if (!file) return;
const { file: uploadedFile, message } = await handleFileUploadImg(file);
  if (message) {
    msgObj.value = { msg: message, role: "danger", show: true };
    event.target.value = ""; 
    return;
  }
  if (uploadedFile) { Obj.value.Image = uploadedFile; }
event.target.value = null;
};
const handleDelete = (row) => {
  delObj.value = { ...row };
}
const rows=ref([])
const  save =async() =>{
      const fields = {
       HolidayName: { value: Obj.value.Name, validators: [isRequired], },
        StartDate: { value: Obj.value.startDate, validators: [isRequired], },
        EndDate: { value: Obj.value.endDate, validators: [isRequired], },
        Note: { value: Obj.value.Note, validators: [isRequired], },
      };
      errors.value = validateForm(fields);
      if (Object.keys(errors.value).length === 0) {
        const { url, method, msg } = curdStatus(Obj.value);
        await api[method](`/Holiday${url}`, Obj.value)
          .then(() => {
            loadData();
            reset();
            msgObj.value = { msg: `Holiday ${msg} Successfully`, role: "success", show: true, };
          })
          .catch((error) => { console.log(error); });
      }
    }
   const reset =async () =>{
      Obj.value = { Name: "", startDate: new Date().toISOString().slice(0, 10), endDate: new Date().toISOString().slice(0, 10), Image: "", Note: "", };
      msgObj.value = { msg: "", role: "", show: false, };
      errors.value={};
    }
    const progress = ref(0)
    const loadData =async () => {
          let direction = 1
     let progressInterval = setInterval(() => {
       progress.value += direction
       if (progress.value >= 100) {
         progress.value = 0 
       }
     }, 100)
      await api.get('/Holiday/all')
        .then((response) => {
          rows.value = response.data.map((item, i) => ({ ...item, Sno: i + 1, 
            Datestart: formatDate(item.startDate),
            Dateend: formatDate(item.endDate),Image: item.Image, }));
          progress.value = 0
          clearInterval(progressInterval)
        });
    }
  const deleteFile = async (filePath) => {
      if (!filePath) return;
      const fileName = filePath.split('/').pop();

      try {
        await api.delete(`/documents/students?filename=${fileName}`);
        Obj.value.Image = '';
      } catch (err) {
        msgObj.value = { msg: 'Failed to delete image.', role: 'danger', show: true };
      }
    };    
    const delRecord =async () => {
      await api.delete(`/Holiday/${delObj.value._id}`)
        .then(() => {
          loadData();
          delObj.value={};
          msgObj.value = { msg: "Holiday Deleted Successfuly.", role: "danger", show: true, };
        });
    }
    const getUrl= (img) => {
      let imgUrl = img.startsWith("..")
          ? img.substring(2)
          : img;
     
  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
    }
  onMounted(() => { loadData() })
</script>